var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRangePriceDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 84,
    viewBox: "0 0 285 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 59,
    width: 10,
    height: 25,
    rx: 1,
    fill: "#565660"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2778,
    y: 77,
    width: 10,
    height: 7,
    rx: 1,
    fill: "#565660"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5557,
    y: 70,
    width: 10,
    height: 14,
    rx: 1,
    fill: "#565660"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8335,
    y: 42,
    width: 10,
    height: 42,
    rx: 1,
    fill: "#3749E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1113,
    y: 57,
    width: 10,
    height: 27,
    rx: 1,
    fill: "#3749E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3887,
    y: 46,
    width: 10,
    height: 38,
    rx: 1,
    fill: "#3749E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6665,
    y: 78,
    width: 10,
    height: 6,
    rx: 1,
    fill: "#3749E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106.944,
    y: 73,
    width: 10,
    height: 11,
    rx: 1,
    fill: "#3749E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 122.222,
    y: 69,
    width: 10,
    height: 15,
    rx: 1,
    fill: "#3749E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 27,
    width: 10,
    height: 57,
    rx: 1,
    fill: "#3749E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 152.778,
    y: 45,
    width: 10,
    height: 39,
    rx: 1,
    fill: "#3749E9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 168.056,
    y: 55,
    width: 10,
    height: 29,
    rx: 1,
    fill: "#3749E9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 183.333,
    width: 10,
    height: 84,
    rx: 1,
    fill: "#3749E9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 198.611,
    y: 45,
    width: 10,
    height: 39,
    rx: 1,
    fill: "#3749E9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 213.889,
    y: 55,
    width: 10,
    height: 29,
    rx: 1,
    fill: "#3749E9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 229.167,
    y: 31,
    width: 10,
    height: 53,
    rx: 1,
    fill: "#3749E9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 244.444,
    y: 8,
    width: 10,
    height: 76,
    rx: 1,
    fill: "#565660"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 259.722,
    y: 66,
    width: 10,
    height: 18,
    rx: 1,
    fill: "#565660"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 66,
    width: 10,
    height: 18,
    rx: 1,
    fill: "#565660"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangePriceDark);
export default __webpack_public_path__ + "static/media/range-price-dark.669687540568e8e38de498037d0a7399.svg";
export { ForwardRef as ReactComponent };